import { render, staticRenderFns } from "./LessonSectionDetail.vue?vue&type=template&id=12b47109&scoped=true"
import script from "./LessonSectionDetail.vue?vue&type=script&lang=js"
export * from "./LessonSectionDetail.vue?vue&type=script&lang=js"
import style0 from "./LessonSectionDetail.vue?vue&type=style&index=0&id=12b47109&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b47109",
  null
  
)

export default component.exports